import {
	chainCommands,
	createParagraphNear,
	liftEmptyBlock,
	newlineInCode,
	splitBlockKeepMarks,
} from "prosemirror-commands";
import { keymap } from "prosemirror-keymap";
import { splitListItem } from "prosemirror-schema-list";
import AbstractAction from "./AbstractAction.js";

/**
 * Action making sure that the style is preserved when the <Enter> key is pressed.
 */
export default class EnsureStyleOnEnterAction extends AbstractAction {
	getPlugins({ schema }) {
		return [
			keymap({
				Enter: chainCommands(
					splitListItem(schema.nodes.list_item),
					newlineInCode,
					createParagraphNear,
					liftEmptyBlock,
					splitBlockKeepMarks,
				),
			}),
		];
	}
}
